import {
  TutoringStudentRoleIds,
  AllTeacherRoleIds,
  AllTutoringAdminRoleIds,
  AllTutoringOpsRoleIds,
} from "@/constants/userRoles";
import { RouteRecordRaw } from "vue-router";

export default [
  {
    path: "/tutoring/manage-paid-students",
    component: () =>
      import(
        /* webpackChunkName: 'TutoringManagePaidStudents' */ "@/views/tutoring/TutoringManagePaidStudents.vue"
      ),
    name: "TutoringManagePaidStudents",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllTutoringOpsRoleIds,
    },
  },
  {
    path: "/tutoring/manage-demo-students",
    component: () =>
      import(
        /* webpackChunkName: 'TutoringManageDemoStudents' */ "@/views/tutoring/TutoringManageDemoStudents.vue"
      ),
    name: "TutoringManageDemoStudents",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllTutoringOpsRoleIds,
    },
  },
  {
    path: "/tutoring/admin-dashboard",
    component: () =>
      import(
        /* webpackChunkName: 'TutoringAdminDashboard' */ "@/views/tutoring/TutoringAdminDashboard.vue"
      ),
    name: "TutoringAdminDashboard",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllTutoringOpsRoleIds,
    },
  },
  {
    path: "/tutoring/book-demo-session/:emailId?",
    component: () =>
      import(
        /* webpackChunkName: 'TutoringBookDemoSession' */ "@/views/tutoring/TutoringBookDemoSession.vue"
      ),
    name: "TutoringBookDemoSession",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllTutoringOpsRoleIds,
    },
  },
  {
    path: "/tutoring/book-paid-sessions/:studentId?",
    component: () =>
      import(
        /* webpackChunkName: 'TutoringBookPaidSessions' */ "@/views/tutoring/TutoringBookPaidSessions.vue"
      ),
    name: "TutoringBookPaidSessions",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllTutoringOpsRoleIds,
    },
  },
  {
    path: "/tutoring/manage-demo-sessions",
    component: () =>
      import(
        /* webpackChunkName: 'TutoringManageDemoSessions' */ "@/views/tutoring/TutoringManageDemoSessions.vue"
      ),
    name: "TutoringManageDemoSessions",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllTutoringOpsRoleIds,
    },
  },
  {
    path: "/tutoring/manage-paid-sessions",
    component: () =>
      import(
        /* webpackChunkName: 'TutoringManagePaidSessions' */ "@/views/tutoring/TutoringManagePaidSessions.vue"
      ),
    name: "TutoringManagePaidSessions",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllTutoringOpsRoleIds,
    },
  },
  {
    path: "/tutoring/tutoring-admin-session-reports",
    component: () =>
      import(
        /* webpackChunkName: 'TutoringAdminSessionReports' */ "@/views/tutoring/TutoringAdminSessionReports.vue"
      ),
    name: "TutoringAdminSessionReports",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllTutoringOpsRoleIds,
    },
  },
  {
    path: "/tutoring/manage-demo-slots",
    component: () =>
      import(
        /* webpackChunkName: 'TutoringManageDemoSlots' */ "@/views/tutoring/TutoringManageDemoSlots.vue"
      ),
    name: "TutoringManageDemoSlots",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllTeacherRoleIds,
    },
  },
  {
    path: "/tutoring/onboard-student",
    component: () =>
      import(
        /* webpackChunkName: 'TutoringOnboardStudent' */ "@/views/tutoring/TutoringOnboardStudent.vue"
      ),
    name: "TutoringOnboardStudent",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllTutoringOpsRoleIds,
    },
  },
  {
    path: "/tutoring/student-dashboard",
    component: () =>
      import(
        /* webpackChunkName: 'TutoringStudentDashboard' */ "@/views/tutoring/TutoringStudentDashboard.vue"
      ),
    name: "TutoringStudentDashboard",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: TutoringStudentRoleIds,
    },
  },
  {
    path: "/tutoring/student-study-notes",
    component: () =>
      import(
        /* webpackChunkName: 'TutoringStudentStudyNotes' */ "@/views/tutoring/TutoringStudentStudyNotes.vue"
      ),
    name: "TutoringStudentStudyNotes",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: TutoringStudentRoleIds,
    },
  },
  {
    path: "/tutoring/student-reports-and-certificates",
    component: () =>
      import(
        /* webpackChunkName: 'TutoringStudentReportsAndCertificates' */ "@/views/tutoring/TutoringStudentReportsAndCertificates.vue"
      ),
    name: "TutoringStudentReportsAndCertificates",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: TutoringStudentRoleIds,
    },
  },
  {
    path: "/tutoring/tutor-dashboard",
    component: () =>
      import(
        /* webpackChunkName: 'TutoringTutorDashboard' */ "@/views/tutoring/TutoringTutorDashboard.vue"
      ),
    name: "TutoringTutorDashboard",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllTeacherRoleIds,
    },
  },
  {
    path: "/tutoring/tutor-lesson-plans",
    component: () =>
      import(
        /* webpackChunkName: 'TutoringTutorLessonPlans' */ "@/views/tutoring/TutoringTutorLessonPlans.vue"
      ),
    name: "TutoringTutorLessonPlans",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllTeacherRoleIds.concat(AllTutoringAdminRoleIds),
    },
  },
  {
    path: "/tutoring/tutor-monthly-report",
    component: () =>
      import(
        /* webpackChunkName: 'TutoringMonthlyReport' */ "@/views/tutoring/TutoringMonthlyReport.vue"
      ),
    name: "TutoringMonthlyReport",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllTutoringOpsRoleIds,
    },
  },
  {
    path: "/tutoring/manage-student/:emailId?",
    component: () =>
      import(
        /* webpackChunkName: 'TutoringManageStudent' */ "@/views/tutoring/TutoringManageStudent.vue"
      ),
    name: "TutoringManageStudent",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllTutoringOpsRoleIds,
    },
  },
  {
    path: "/tutoring/manage-tutors",
    component: () =>
      import(
        /* webpackChunkName: 'TutoringManageTutors' */ "@/views/tutoring/TutoringManageTutors.vue"
      ),
    name: "TutoringManageTutors",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllTutoringOpsRoleIds,
    },
  },
] as unknown as Array<RouteRecordRaw>;
